module.exports = __webpack_public_path__ + "static/media/orange-box.e52b1198.png";